import React, { Suspense } from 'react';
import { useRecoilValue } from 'recoil';
import { useTranslation } from 'react-i18next';
import { NumberParam, useQueryParam } from 'use-query-params';
import {
    Box, Button, Card,
    CardHeader, Container, IconButton, Link,
} from '@mui/material';
import { Add, Delete, Edit } from '@mui/icons-material';
import { DataGrid, GridActionsCellItem, GridColDef } from '@mui/x-data-grid';
import useBLModals from 'modules/voyages/hooks/useBLModals';
import blTypeList from 'recoil/atoms/BLTypeList';


const Inner = () => {
    const {t} = useTranslation();
    const [voyageId] = useQueryParam('voyage', NumberParam);
    const types = useRecoilValue(blTypeList);
    const modals = useBLModals();

    const mainAction = <>
        {voyageId && (
            <Button
                component={Link}
                size="small"
                href={`/voyage/${voyageId}/bl`}
            >
                {t('back')}
            </Button>
        )}
        {' '}
        <IconButton
            aria-label="add bl type"
            onClick={() => modals.openAddBLTypeModal()}
        >
            <Add/>
        </IconButton>
    </>;

    const columns: GridColDef<any>[] = [
        {
            field: 'type',
            headerName: t('type'),
            width: 100,
        },
        {
            field: 'name',
            headerName: t('name'),
            minWidth: 200,
            flex: 1,
        },
        {
            field: 'description',
            headerName: t('description'),
            minWidth: 200,
            flex: 1,
        },
        {
            field: 'actions',
            type: 'actions',
            getActions: params => [
                <GridActionsCellItem
                    key="edit"
                    icon={<Edit/>}
                    label={t('edit')}
                    onClick={() => modals.openEditBLTypeModal(params.row)}
                />,
                <GridActionsCellItem
                    key="delete"
                    icon={<Delete/>}
                    label={t('delete')}
                    onClick={() => modals.confirmDeleteBLType(params.row)}
                />
            ],
        },
    ];

    return (
        <Container maxWidth={false} sx={{mt: 2}}>
            <Card sx={{mb: 2}}>
                <CardHeader
                    title={t('bl_types')}
                    action={mainAction}
                />
                <Box sx={{height: 'calc(100vh - 148px)', padding: '0 1rem'}}>
                    <DataGrid
                        rows={types}
                        columns={columns}
                        disableRowSelectionOnClick
                    />
                </Box>
            </Card>
        </Container>
    );
};


const BLTypes = () => {
    return (
        <Suspense fallback={null}>
            <Inner/>
        </Suspense>
    )
};

export default BLTypes;
